import { Component, OnInit } from '@angular/core';
import { _ } from 'underscore';
import {
  Router,
  ActivatedRoute,
  NavigationStart,
  NavigationEnd,
} from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  showLogin = true;
  url = environment.api_url;
  constructor(private router: Router, private http: HttpClient) {}
  ngOnInit() {
    const user = sessionStorage.getItem('userObj');
    if (user) {
      this.showLogin = false;
      let questionnarieObj = sessionStorage.getItem('userResponse');
      let percentage = sessionStorage.getItem('percentage');
      if (questionnarieObj && user) {
        const body = new HttpParams()
          .append('questionnarieObj', questionnarieObj)
          .append('userObj', user)
          .append('percentage', percentage);
        this.http
          .post(this.url + '/saveQuestions', body)
          .subscribe((res: any) => {
            console.log(res);
          });
      }
    }
  }

  contactuss() {
    sessionStorage.setItem('contcusFlag', 'contact');
    sessionStorage.removeItem('faqFlag');
  }

  logoutFun() {
    sessionStorage.clear();
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: this.router.url },
    });
  }

  gotoProfile() {
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      this.showLogin = false;
      let result = JSON.parse(sessionStorage.getItem('userObj'));
      if (result.hg_accountId) {
        this.router.navigate(['user-settings', result.hg_accountId]);
      } else {
        this.router.navigate(['user-settings', result._id]);
      }
    }
  }

  addClass($event) {
    const elementObj = document.getElementById('menuIcon');
    const navElement = document.getElementById('navbarsExampleDefault');
    if (navElement.classList.contains('show')) {
      elementObj.classList.remove('listicn');
      elementObj.classList.add('closeicn');
      elementObj['src'] = 'assets/images/list.png';
    } else {
      elementObj.classList.remove('closeicn');
      elementObj.classList.add('listicn');
      elementObj['src'] = 'assets/images/close.svg';
    }
  }
}
